import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { accountDetailNavigation, useMixedNavigation } from './useMixedNavigation'

export function usePageBreadcrumb() {
  const route = useRoute()
  const router = useRouter()
  const { modules } = useMixedNavigation()
  const menuPages = computed(() => {
    const pages: any[] = []
    function visit(items: any[]) {
      for (const item of items) {
        if (item.hidden) continue
        if (item.children?.length) visit(item.children)
        else if (item.path.startsWith('/') && item.meta?.title) pages.push(item)
      }
    }
    visit(modules.value)
    return pages
  })
  const items = computed(() => {
    if (route.meta.breadcrumb === false || route.path === '/index' || route.path.startsWith('/redirect/')) return []
    const accountDetail = accountDetailNavigation(route.path)
    if (accountDetail) {
      const parent = {
        path: '/users-and-accounts',
        meta: { title: accountDetail.listTitle, menuIndex: `account-${accountDetail.category}` },
        to: { path: '/users-and-accounts', query: { tab: accountDetail.tab } }
      }
      const trail: any[] = [parent]
      if (accountDetail.category === 'teaching') {
        trail.unshift({
          path: '/users-and-accounts/teaching',
          meta: { title: '教学账号' },
          to: parent.to
        })
      }
      trail.push({ path: route.path, meta: { title: accountDetail.detailTitle } })
      return trail
    }
    // A page reachable directly from the permitted navigation needs no duplicate trail.
    const directPage = menuPages.value.some(page =>
      page.path === route.path || (page.name && page.name === route.name) ||
      (typeof page.redirect === 'string' && page.redirect === route.path)
    )
    if (directPage) return []

    // Hidden detail/edit routes use activeMenu to identify their owning list.
    // Otherwise use the closest real menu page ancestor, never a directory link.
    const parent = menuPages.value.find(page => page.path === route.meta.activeMenu) ||
      menuPages.value.filter(page => route.path.startsWith(page.path + '/'))
        .sort((a, b) => b.path.length - a.path.length)[0]
    const result: any[] = []
    if (parent && parent.meta.breadcrumb !== false && router.resolve(parent.path).matched.length) {
      let query = parent.query
      if (typeof query === 'string') {
        try { query = JSON.parse(query) } catch { query = undefined }
      }
      result.push({ path: parent.path, meta: parent.meta, to: { path: parent.path, query } })
    }
    if (route.meta.title) result.push({ path: route.path, meta: route.meta })
    return result
  })
  const showBreadcrumb = computed(() => items.value.length > 0)
  return { items, showBreadcrumb }
}
